module.exports = __webpack_public_path__ + "img/celtic-fc-logo-icon.ce072300.png";